export default __webpack_public_path__ + "static/media/Cloudxier_graphics-each-expertise-01.a8b30ee9.png";